const statusOptions = [
  { value: 'off',   label: 'Off' },
  { value: 'paused', label: 'Paused' },
  { value: 'hidden', label: 'Hidden' },
  { value: 'visible', label: 'Visible' },
];

export default statusOptions;
